<script setup lang="ts">
const termsAndConditions = ref("");
const { $i18n } = useNuxtApp();

onMounted(() => {
  fetch(`/api/policies/InfluencerTerms?locale=${$i18n.locale.value}`)
    .then((response) => response.text())
    .then((data) => {
      const tempDiv = document.createElement("div");
      tempDiv.innerHTML = String(data ?? "");
      const styleTags = tempDiv.getElementsByTagName("style");
      Array.from(styleTags).forEach((style) => {
        let cssText = style.innerHTML;
        cssText = cssText.replace(/([^{}]*){/g, ".terms-container $1{");
        style.innerHTML = cssText;
      });

      termsAndConditions.value = tempDiv.innerHTML;
    });
});
// Steps for preparing html doc:
// Ensure line-height is set to 2 everywhere
// add to html tag: style="padding-right: 20px"
// anchor tags should have target="_blank" and cleanup the hrefs (remove google redirect and &amp;)
</script>

<template>
  <h1 class="text-5xl font-bold tracking-tight text-neutral-200 mb-10">
    {{ $t("main.pageLegal.influencerTermsAndConditions") }}
  </h1>
  <div class="terms-container" v-html="termsAndConditions"></div>
</template>
<style scoped>
.terms-container {
  line-height: 2;
  padding-right: 20px;
  color: #f3f3f3;
}
</style>
